import { initI18n } from './i18n-provider';
export var getLanguage = function () { return getInitialI18n().lang || 'en'; };
export var getTranslations = function () { return getInitialI18n().localeData; };
export var initClientI18n = function () { return initI18n(getLanguage(), getTranslations()); };
function getInitialI18n() {
    return window.__INITIAL_I18N__ || {};
}
